// JsFromRoutes CacheKey d7c7a0fcc34037231d6e1e4294e395f5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/content_strategy'),
}
